import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CurrentComponent } from './tabs/current/current.component';
import { MapModule } from 'src/app/shared/modules/map/map.module';
import { ChartModule } from '@kiwigrid/ngx-highcharts';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import * as Highcharts from 'highcharts/highstock';
import { HighchartsStatic } from '@kiwigrid/ngx-highcharts/dist/HighchartsService';
import { FormsModule } from '@angular/forms';
import { TabLoadingService } from './tabs/utils/tab-loading.service';
import { LayoutComponentsModule } from 'src/app/shared/modules/layout-components.module';
import { TourMatMenuModule } from 'ngx-tour-md-menu';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { MomentModule } from 'ngx-moment';

export function highchartsFactory() {
    const hcm = require('highcharts/highcharts-more');
    const exp = require('highcharts/modules/exporting');
    const sg = require('highcharts/modules/solid-gauge');

    Highcharts.setOptions({
        lang: {
            rangeSelectorZoom: 'Zoom/Display: '
        }
    } as any);

    hcm(Highcharts);
    exp(Highcharts);
    sg(Highcharts);
    return Highcharts;
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DashboardRoutingModule,
        MapModule,
        ChartModule,
        NgxDatatableModule,
        BsDatepickerModule.forRoot(),
        DatepickerModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        LayoutComponentsModule,

        TourMatMenuModule,
        MomentModule
    ],
    declarations: [
        DashboardComponent,
        DisclaimerComponent,
        TutorialComponent,
        CurrentComponent
    ],
    providers: [
        TabLoadingService,
        { provide: HighchartsStatic, useFactory: highchartsFactory }
    ],
    entryComponents: [
        DisclaimerComponent,
        TutorialComponent
    ]
})
export class DashboardModule { }
